import { graphql } from 'gatsby';
import React from 'react';

import Spacer from '~/components/blocks/core/Spacer';
import PropTypes from 'prop-types';

const SpacerBlock = ({ attrs }) => <Spacer {...attrs} />;

SpacerBlock.propTypes = {
    attrs: PropTypes.shape({
        heightString: PropTypes.string.isRequired,
        anchor: PropTypes.string,
        className: PropTypes.string
    }).isRequired
};

export default SpacerBlock;

export const fragment = graphql`
    fragment SpacerBlockFragment on WpCoreSpacerBlock {
        name
        attrs: attributes {
            ... on WpCoreSpacerBlockAttributes {
                anchor
                className
                heightString: height
            }
        }
    }
`;

export const exampleData = [
    {
        variant: '100px Spacer',
        description: 'Height of spacer can be set in px, em or rem.',
        props: {
            name: 'core/spacer',
            attrs: {
                heightString: '100px'
            }
        }
    }
];
